import { render } from "./NavbarVac.vue?vue&type=template&id=2364062c&scoped=true"
import script from "./NavbarVac.vue?vue&type=script&lang=js"
export * from "./NavbarVac.vue?vue&type=script&lang=js"

import "./NavbarVac.vue?vue&type=style&index=0&id=2364062c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2364062c"]])

export default __exports__